module.exports = __webpack_public_path__ + "static/media/alley_brussels.cf2c6140.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/alley_brussels.jpg
// module id = 398
// module chunks = 0